import { http } from "@/plugins/http";

import {
  ApiResponse,
  Client,
  ClientConfirmationClaim,
  RegistrationClaim
} from "@/types";

export const Api = {
  async confirmPhone(claim: ClientConfirmationClaim): Promise<ApiResponse> {
    return http.post("/clients/verificationCode?lang=ru", claim);
  },

  async isFreeName(name: string): Promise<boolean> {
    return (await http.get(`clients/${name}/?lang=ru`)).data;
  },

  async registerClient(claim: RegistrationClaim): Promise<Client> {
    return (await http.post("/clients?lang=ru", claim)).data;
  },

  async resendVerificationCode(login: string): Promise<ApiResponse> {
    return http.get(`/clients/verificationCode/${login}/3?lang=ru`);
  }
};
